import React from 'react';
import { IconSvgProps } from '@models/common';

const NavPlagiarism: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.31771 18.9996V5.00039C5.31771 4.59948 5.46361 4.39617 5.61302 4.27383C5.79592 4.1241 6.04822 4.05002 6.247 4.05H17.4677C17.9924 4.05 18.4181 4.47572 18.4181 5.00039V11.1996C18.4181 11.7795 18.8882 12.2496 19.4681 12.2496C20.048 12.2496 20.5181 11.7795 20.5181 11.1996V5.00039C20.5181 3.31592 19.1522 1.95 17.4677 1.95H6.247C5.62028 1.95001 4.88307 2.1582 4.28294 2.64961C3.64926 3.16851 3.21771 3.96629 3.21771 5.00039V18.9996C3.21771 20.6841 4.58363 22.05 6.2681 22.05H8.46771C9.04761 22.05 9.51771 21.5799 9.51771 21C9.51771 20.4201 9.04761 19.95 8.46771 19.95H6.2681C5.74343 19.95 5.31771 19.5243 5.31771 18.9996Z'
        fill='currentColor'
      />
      <path
        d='M8.26116 8.85242C7.68126 8.85242 7.21116 8.38232 7.21116 7.80242C7.21116 7.22252 7.68126 6.75242 8.26116 6.75242H15.1647C15.7446 6.75242 16.2147 7.22252 16.2147 7.80242C16.2147 8.38232 15.7446 8.85242 15.1647 8.85242H8.26116Z'
        fill='currentColor'
      />
      <path
        d='M8.26085 13.05C7.6812 13.0497 7.21085 12.5797 7.21085 12C7.21085 11.4203 7.6812 10.9503 8.26085 10.95L9.23675 10.95C9.81665 10.95 10.2867 11.4201 10.2867 12C10.2867 12.5799 9.81665 13.05 9.23675 13.05L8.26085 13.05Z'
        fill='currentColor'
      />
      <path
        d='M16.6996 17.1938C16.6995 16.2307 15.9189 15.45 14.9558 15.45C13.9928 15.45 13.2121 16.2307 13.2121 17.1938C13.2121 18.1568 13.9928 18.9375 14.9558 18.9375C15.9189 18.9375 16.6996 18.1568 16.6996 17.1938ZM19.0996 17.1938C19.0996 17.9013 18.9212 18.5669 18.6086 19.1496L20.4308 20.9707C20.8995 21.4393 20.8995 22.2001 20.4308 22.6688C19.9622 23.1374 19.2014 23.1374 18.7328 22.6688L16.9117 20.8465C16.329 21.1591 15.6634 21.3375 14.9558 21.3375C12.6673 21.3375 10.8121 19.4823 10.8121 17.1938C10.8121 14.9052 12.6673 13.05 14.9558 13.05C17.2444 13.05 19.0995 14.9052 19.0996 17.1938Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default NavPlagiarism;
